import { render, staticRenderFns } from "./EventSponsors.vue?vue&type=template&id=8b7bcbf6"
import script from "./EventSponsors.vue?vue&type=script&lang=js"
export * from "./EventSponsors.vue?vue&type=script&lang=js"
import style0 from "./EventSponsors.vue?vue&type=style&index=0&id=8b7bcbf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports